import React, { Component } from 'react';
import {
  Row, Col, Button, Card, CardBody
} from 'reactstrap';
import { connect } from 'react-redux';
import Sidebar from 'react-sidebar';
import swal from 'sweetalert';
import Ionicon from 'react-ionicons';
import moment from 'moment';
import * as Scroll from 'react-scroll';
// components
import ProfileDetail from '../../components/ProfileDetail/ProfileDetail';
import EditOtherBusinessDetail from '../../components/EditOtherBusinessDetail/EditOtherBusinessDetail';
import EditPrimaryContactDetail from '../../components/EditPrimaryContactDetail/EditPrimaryContactDetail';
import EditSocialDetails from '../../components/EditSocialDetails/EditSocialDetails';
import DetailCard from '../../components/DetailCard/DetailCard';
// import EditFleetDetail from '../../components/EditFleetDetail/EditFleetDetail';
import ListSubsidiaries from '../../components/ListSubsidiaries/ListSubsidiaries';
import AddEditSubsidiaries from '../../components/AddEditSubsidiaries/AddEditSubsidiaries';
import ActionScreen from '../../components/ActionScreen/ActionScreen';

// services
import UserService from "../../services/UserService";
import Validation from "../../services/Validation";
import { messages } from "../../constants/constant.message";
import AddEditSubsidiariesService from "../../services/AddEditSubsidiariesService";
import SpecialEngagementService from "../../services/SpecialEngagementService";

// actions
import { setUserDetail, isProfileUpdate } from "../../actions/UserAction";

// css
import './Profile.css';
import FleetService from '../../services/FleetService';
import FleetRegistration from '../../components/FleetRegistration/FleetRegistration';
import NewFleetCommunicationDetail from '../../components/NewFleetCommunicationDetail/NewFleetCommunicationDetail';
import NewFleetPersonalDetails from '../../components/NewFleetPersonalDetails/NewFleetPersonalDetails';
import VehicleCountDeatil from '../../components/VehicleCountDeatil/VehicleCountDeatil';
// import VehicleDetail from '../../components/VehicleDetail/VehicleDetail';
import AddEditFleetVehicle from '../../components/AddEditFleetVehicle/AddEditFleetVehicle';
import CustomSpinner from '../../components/CustomSpinner/CustomSpinner';
import ModalService from '../../services/ModalService';

class Profile extends Component {
  state = {
    isLoading: false,
    isFleeData: false,
    showBuildMyFleet: false,
    editSubsidiariesIndex: 0,
    isAddSubsidiaries: true,
    sidebarOpen: false,
    profileImage: null,
    sapId: null,
    businessName: null,
    ownerName: null,
    address: null,
    isUpdateProfileRequestSend: true,
    isBusinessEditActive: false,
    isContactEditActive: false,
    isCommuncationEditActive: false,
    isPersonalDetailEditActive: false,
    isSocialEditActive: false,
    isImageUpdating: false,
    isOpenAddEditVehicle: false,
    isAddVehicleDetail: false,
    vehicleData: {},
    all_mandtory_error: {
      is_business: false,
      is_communication: false,
      is_personal: false,
      is_primary: false
    },
    controls: {
      company_name: {
        value: '',
        valid: null,
        touched: false,
        nullValue: null,
        invalidEmail: null,
        required: true,
        showErrorMsg: false,
        autoFocus: false
      },
      company_type: {
        value: '',
        valid: null,
        touched: false,
        nullValue: null,
        invalidEmail: null,
        required: true,
        showErrorMsg: false,
        autoFocus: false
      },
      owner_name: {
        value: '',
        valid: null,
        touched: false,
        nullValue: null,
        invalidEmail: null,
        required: true,
        showErrorMsg: false,
        autoFocus: false
      },
      designation: {
        value: '',
        valid: null,
        touched: false,
        nullValue: null,
        invalidEmail: null,
        required: true,
        showErrorMsg: false,
        autoFocus: false
      },
      mobile_number: {
        value: '',
        valid: null,
        touched: false,
        nullValue: null,
        invalidPhone: null,
        required: true,
        showErrorMsg: false,
        autoFocus: false
      },
      state: {
        value: null,
        valid: true,
        required: false,
        touched: false,
        invalidLength: null,
        showErrorMsg: false
      },
      city: {
        value: null,
        valid: true,
        required: false,
        touched: false,
        invalidLength: null,
        showErrorMsg: false
      },
      pin_code: {
        value: null,
        valid: true,
        touched: false,
        required: false,
        showErrorMsg: false
      },
      address: {
        value: null,
        valid: true,
        touched: false,
        required: false,
        invalidLength: null,
        showErrorMsg: false
      },
      email: {
        value: "",
        valid: null,
        touched: false,
        nullValue: null,
        invalidEmail: null,
        required: true,
        showErrorMsg: false,
        autoFocus: false,
      },
      phone: {
        value: "",
        valid: null,
        touched: false,
        nullValue: null,
        invalidPhone: null,
        required: true,
        showErrorMsg: false,
        autoFocus: false,
      },
      gst: {
        value: null,
        valid: true,
        touched: false,
        required: false,
        invalidLength: null,
        showErrorMsg: false,
      },
      pan: {
        value: null,
        valid: true,
        required: false,
        touched: false,
        invalidLength: null,
        showErrorMsg: false,
      },
      wa: {
        value: null,
        valid: true,
        required: false,
        touched: false,
        invalidLength: null,
        showErrorMsg: false,
      },
      primaryPerson: {
        value: null,
        valid: true,
        touched: false,
        required: false,
        showErrorMsg: false,
      },
      primaryEmail: {
        value: "",
        valid: null,
        touched: false,
        nullValue: null,
        invalidEmail: null,
        required: true,
        showErrorMsg: false,
        autoFocus: false,
      },
      primaryDesignation: {
        value: null,
        valid: true,
        touched: false,
        required: false,
        showErrorMsg: false,
      },
      primaryNumber: {
        value: '',
        valid: true,
        invalidPhone: null,
        touched: false,
        required: false,
        showErrorMsg: false,
      },
      primaryWa: {
        value: '',
        valid: false,
        touched: false,
        invalidPhone: null,
        required: false,
        showErrorMsg: false,
        autoFocus: false,
      },
      birthDate: {
        value: null,
        valid: null,
        touched: false,
        required: true,
        showErrorMsg: false,
      },
      anniversaryDate: {
        value: null,
        valid: true,
        touched: false,
        required: false,
        showErrorMsg: false,
      },
      facebook: {
        value: null,
        valid: true,
        touched: false,
        required: false,
        showErrorMsg: false,
      },
      instagram: {
        value: null,
        valid: true,
        touched: false,
        required: false,
        showErrorMsg: false,
      },
      website: {
        value: null,
        valid: true,
        touched: false,
        required: true,
        showErrorMsg: false,
      },
      truck: {
        value: null,
        valid: true,
        touched: false,
        required: true,
        showErrorMsg: false,
        isEditActive: false,
      },
      bus: {
        value: null,
        valid: true,
        touched: false,
        required: true,
        showErrorMsg: false,
        isEditActive: false,
      },
      scv: {
        value: null,
        valid: true,
        touched: false,
        required: true,
        showErrorMsg: false,
        isEditActive: false,
      },
      lcv: {
        value: null,
        valid: true,
        touched: false,
        required: true,
        showErrorMsg: false,
        isEditActive: false,
      },
      agreeTermAndCondition: true,
      sameAsUser: false,
    },
    businessCardObj: {
      title: 'COMPANY DETAILS',
      edit: 'isBusinessEditActive',
      fields: [
        {
          title: 'Company Name',
          value: null
        },
        {
          title: 'Owner Name',
          value: null
        },

        {
          title: 'Company Type',
          value: null
        },
        {
          title: 'Designation',
          value: null
        },
        {
          title: 'Mobile Number',
          value: null
        },
        {
          title: 'Whatsapp Number',
          value: null
        },
        {
          title: 'Phone Number',
          value: null
        },
        {
          title: 'Email Address',
          value: null
        },
        {
          title: 'GST Number',
          value: null
        },
        {
          title: "PAN",
          value: null,
        },
        {
          title: 'Address',
          value: null
        },
        {
          title: 'State',
          value: null
        },
        {
          title: 'City',
          value: null
        },
        {
          title: 'Pincode',
          value: null
        }
      ]
    },
    contactCardObj: {
      title: "PRIMARY CONTACT DETAILS",
      edit: "isContactEditActive",
      fields: [
        {
          title: "Contact Person",
          value: null,
        },
        {
          title: "Contact Number",
          value: null,
        },
        {
          title: "Email Address",
          value: null,
        },
        {
          title: "Whatsapp Number",
          value: null,
        },
        {
          title: "Designation",
          value: null,
        },
      ],
    },
    communcationCardObj: {
      title: 'COMMUNICATION DETAILS',
      edit: 'isCommuncationEditActive',
      fields: [
        {
          title: 'Address',
          value: null
        },
        {
          title: 'State',
          value: null
        },
        {
          title: 'City',
          value: null
        },
        {
          title: 'Pincode',
          value: null
        }
      ]
    },
    personalDetailCardObj: {
      title: 'PERSONAL DETAILS',
      edit: 'isPersonalDetailEditActive',
      fields: [
        {
          title: 'Home Address',
          value: null
        },
        {
          title: 'Date of Birth',
          value: null
        },
        {
          title: 'Educational Qualification',
          value: null
        },
        {
          title: 'Languages Known',
          value: null,
          isArray: true
        },
        {
          title: 'Marital Status',
          value: null
        }
      ]
    },
    socialCardObj: {
      title: 'SOCIAL DETAILS',
      edit: 'isSocialEditActive',
      fields: [
        {
          title: 'Facebook Page',
          value: null
        },
        {
          title: "Instagram Page",
          value: null,
        },
        {
          title: "Website",
          value: null,
        },
      ],
    },
    birthDate: null,
    anniversaryDate: null,
    detailObj: {
      email: "arpan@gmail.com",
      phone: "+91 46546516511",
      gst: null,
      pan: null,
      alPerson: null,
      alDesignation: null,
      alNumber: null,
      wa: null,
      birthDate: "2019/12/29",
      anniversaryDate: null,
      facebook: null,
      instagram: null,
    },
    uDetail: {},
    isListSubsidiaries: false,
    activeFragment: null,
    isBusinessFormValid: false,
    isContactFormValid: false,
    isSocialFormValid: false,
    fleet_id: null,
    fleetData: [],
  };

  addEditSubsidiariesArr = [];

  isListSubsidiaries = false;

  constructor(props) {
    super(props);
    this.stateAddEditSubsidiaries = {
      addEditSubsidiaries: [],
    };
    this.childFleetBusinessDetail = React.createRef();
    this.childNewFleetCommunicationDetail = React.createRef();
    this.childNewFleetPersonalDetails = React.createRef();
    this.childPrimaryContact = React.createRef();
    this.refEditOtherBusinessDetail = React.createRef();
  }

  dynamicAddEditSubsidiaries = () => {
    this.stateAddEditSubsidiaries.addEditSubsidiaries.push(
      Object.assign(
        {},
        {
          controls: {
            id: "",
            uuid: "",
            pin_code: {
              value: "",
              valid: null,
              touched: false,
              message: null,
              nullValue: null,
              invalidFirstname: null,
              databaseFieldName: "pin_code",
            },
            sap_id: {
              value: "",
              valid: null,
              touched: false,
              message: null,
              nullValue: null,
              invalidFirstname: null,
              databaseFieldName: "sap_id",
            },
            subsidiaryName: {
              value: "",
              valid: null,
              touched: false,
              message: null,
              nullValue: null,
              invalidFirstname: null,
              databaseFieldName: "subsidiaryName",
            },
            address1: {
              value: "",
              valid: null,
              touched: false,
              message: null,
              nullValue: null,
              invalidFirstname: null,
              databaseFieldName: "address_1",
            },
            address2: {
              value: "",
              valid: null,
              touched: false,
              message: null,
              nullValue: null,
              invalidFirstname: null,
              databaseFieldName: "address_2",
            },
            state: {
              value: "",
              valid: null,
              touched: false,
              message: null,
              nullValue: null,
              invalidFirstname: null,
              databaseFieldName: "state_id",
            },
            city: {
              value: "",
              valid: null,
              touched: false,
              message: null,
              nullValue: null,
              invalidFirstname: null,
              databaseFieldName: "city_id",
            },
            gst: {
              value: "",
              valid: true,
              touched: false,
              required: false,
              invalidLength: null,
              showErrorMsg: false,
              databaseFieldName: "gst_number",
            },
            pan: {
              value: "",
              valid: true,
              required: false,
              touched: false,
              invalidLength: null,
              showErrorMsg: false,
              databaseFieldName: "pan_number",
            },
          },
          popupTitles: [],
          isValidForm: false,
        }
      )
    );
  };

  componentDidMount() {
    window.addEventListener("resize", this.resizeWindow);
    this.getUserDetail();
    this.getSubsidiaries();
    this.getFleetData();
    this.getBusinessRelatedDetail();
    this.getUserPopupTitles();
  }

  componentWillMount() {

    const query = new URLSearchParams(this.props.location.search);
    const fleetId = query.get("fleetId");
    this.setState({ fleet_id: fleetId });

  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeWindow);
  }

  resizeWindow = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  getUserDetail = () => {
    this.setState({ isLoading: true });
    UserService.getUserInfo(this.state.fleet_id)
      .then((data) => {
        const userData = data.data.data;
        this.props.setUserDetail(userData);
        this.setPageValues(userData);
        // uncomment this if block

        // if (userData.is_login_first_time === true) {
        this.setState({ redirectToOnBoarding: true, uDetail: userData });
        // }
      })
      .catch((e) => {
        console.error("e", e);
      });
  };

  getSubsidiaries() {
    this.setState({ isLoading: true });
    AddEditSubsidiariesService.getSubsidiariesProfile(this.state.fleet_id)
      .then((response) => {
        let isDisplayedSubsidiariesConfirmModal = false;
        if (
          response.data &&
          response.data.data &&
          response.data.data.length > 0
        ) {
          this.stateAddEditSubsidiaries.addEditSubsidiaries = [];
          response.data.data.forEach((element) => {
            this.dynamicAddEditSubsidiaries();
          });
          this.isListSubsidiaries = true;
          response.data.data.forEach((element, i) => {
            this.stateAddEditSubsidiaries.addEditSubsidiaries[
              i
            ].controls.sap_id.value = element.sap_id;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[
              i
            ].controls.address1.value = element.address_1;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[
              i
            ].controls.address2.value = element.address_2;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[
              i
            ].controls.city.value = element.city_name;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[
              i
            ].controls.gst.value = element.gst_number;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[
              i
            ].controls.pan.value = element.pan_number;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[
              i
            ].controls.state.value = element.state_name;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[
              i
            ].controls.subsidiaryName.value = element.subsidiary_name;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.id =
              element.id;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.uuid =
              element.uuid;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[
              i
            ].controls.pin_code.value = element.pin_code;
          });
          isDisplayedSubsidiariesConfirmModal = true;
          this.setState({ isListSubsidiaries: true, isLoading: false });
        } else {
          this.stateAddEditSubsidiaries.addEditSubsidiaries = [];
          this.setState({ isListSubsidiaries: false, isLoading: false });
        }
        this.setState((prevState) => ({
          ...prevState,
          isDisplayedSubsidiariesConfirmModal,
          isLoading: false
        }));
      })
      .catch((e) => {
        console.error("e", e);
      });
  }

  setPageValues = (uDetail) => {
    const {
      email_1,
      telephone_no_1,
      gst_number,
      pan_number,
      whats_app_number_user,
      image_url,
      alternate_contact_person,
      alternate_contact_number,
      alternate_contact_email,
      // designation,
      whats_app_number,
      birth_date,
      anniversary_date,
      facebook_url,
      instagram_url,
      member_id,
      business_name,
      owner_name,
      address_line_1,
      address_line_2,
      address_line_3,
      address_line_4,
      website: web_from_api,
      truck: truck_from_api,
      lcv: lcv_from_api,
      scv: scv_from_api,
      bus: bus_from_api,
    } = uDetail;

    let { controls, sapId, address, businessName, profileImage,
      businessCardObj, contactCardObj, socialCardObj, ownerName,
      birthDate: bDayMaster, anniversaryDate: aDayMaster,
      // communcationCardObj
    } = this.state;

    const {
      email,
      phone,
      gst,
      pan,
      wa,
      primaryPerson,
      primaryNumber,
      primaryDesignation,
      primaryEmail,
      primaryWa,
      birthDate,
      anniversaryDate,
      facebook,
      instagram,
      website,
      truck,
      bus,
      lcv,
      scv,
      isUpdateProfileRequestSend,
    } = controls;

    controls.owner_name.value = uDetail.owner_name;
    controls.company_name.value = uDetail.company_name;
    controls.company_type.value = uDetail.company_type;
    controls.designation.value = uDetail.designation;
    controls.mobile_number.value = uDetail.mobile_number;
    controls.address.value = uDetail.address;
    controls.state.value = uDetail.state;
    // if (this.childFleetBusinessDetail.current) {
    //   this.childFleetBusinessDetail.current.getCity(controls.state.value);
    // }

    controls.city.value = uDetail.city;
    controls.pin_code.value = uDetail.pin_code;

    if (this.childNewFleetCommunicationDetail.current) {
      this.childNewFleetCommunicationDetail.current.setFleetDetail(uDetail);
    }
    if (this.childNewFleetPersonalDetails.current) {
      if (uDetail.child_1_date_of_birth) {
        uDetail.child_1_dob = uDetail.child_1_date_of_birth;
      }
      if (uDetail.child_2_date_of_birth) {
        uDetail.child_2_dob = uDetail.child_2_date_of_birth;
      }
      if (uDetail.spouse_date_of_birth) {
        uDetail.spouse_dob = uDetail.spouse_date_of_birth;
      }
      if (uDetail.educational_qualification) {
        uDetail.education_qualification = uDetail.educational_qualification;
      }
      this.childNewFleetPersonalDetails.current.setFleetDetail(uDetail);
    }
    profileImage = image_url;
    email.value = email_1;
    phone.value = telephone_no_1;
    // phone.value = null;
    gst.value = gst_number;
    pan.value = pan_number;
    wa.value = whats_app_number_user;

    primaryPerson.value = alternate_contact_person;
    primaryNumber.value = alternate_contact_number;
    primaryDesignation.value = uDetail.alternate_designation;
    primaryWa.value = whats_app_number;
    primaryEmail.value = alternate_contact_email;

    // birthDate.value = null;
    // anniversaryDate.value = null;
    bDayMaster = birth_date;
    aDayMaster = anniversary_date;
    birthDate.value = birth_date ? new Date(birth_date) : null;
    anniversaryDate.value = anniversary_date
      ? new Date(anniversary_date)
      : null;
    facebook.value = facebook_url;
    instagram.value = instagram_url;
    website.value = web_from_api;

    truck.value = truck_from_api;
    bus.value = bus_from_api;
    scv.value = scv_from_api;
    lcv.value = lcv_from_api;

    sapId = member_id;
    businessName = business_name;
    ownerName = owner_name;
    address = `${address_line_1}`;
    if (address_line_2) {
      address = `${address}, ${address_line_2}`;
    }
    if (address_line_3) {
      address = `${address}, ${address_line_3}`;
    }
    if (address_line_4) {
      address = `${address}, ${address_line_4}`;
    }

    let businessFields = businessCardObj.fields;
    businessFields[0].value = uDetail.company_name;
    businessFields[1].value = uDetail.owner_name;
    businessFields[2].value = uDetail.company_type;
    businessFields[3].value = uDetail.designation;
    businessFields[4].value = uDetail.mobile_number;

    businessFields[5].value = uDetail.whats_app_number_user;
    businessFields[6].value = uDetail.telephone_no_1;
    businessFields[7].value = uDetail.email_1;
    businessFields[8].value = uDetail.gst_number ? uDetail.gst_number : '';
    businessFields[9].value = uDetail.pan_number;
    businessFields[10].value = uDetail.address;

    businessFields[11].value = uDetail.state
    businessFields[12].value = uDetail.city;
    businessFields[13].value = uDetail.pin_code;

    const contactFields = contactCardObj.fields;
    contactFields[0].value = alternate_contact_person;
    contactFields[1].value = alternate_contact_number;
    contactFields[2].value = alternate_contact_email;
    contactFields[3].value = whats_app_number;
    contactFields[4].value = primaryDesignation.value;



    let socialFiels = socialCardObj.fields;

    socialFiels[0].value = facebook_url;
    socialFiels[1].value = instagram_url;
    socialFiels[2].value = web_from_api;

    // isUpdateProfileRequestSend = is_update_profile_request_send;
    this.setState({
      controls, sapId, businessName,
      address, profileImage, businessCardObj,
      contactCardObj, socialCardObj,
      isUpdateProfileRequestSend, ownerName,
      bDayMaster, aDayMaster
    }, () => {
      if (this.childFleetBusinessDetail.current) {
        this.childFleetBusinessDetail.current.getState();
      }
    });

    this.businessFormValidation(true);
    this.contactFormValidation(true);
    this.socialFormValidation(true);
  };

  /**
   * @param firstTime when form loads for first time directly error showing makes bad experience
   *            so do not show any message for null values but disable save button if
   *            there is something missing or some error.
   */
  businessFormValidation = (firstTime) => {
    let { controls, isBusinessFormValid } = this.state;
    let { email, phone, gst, pan, wa } = controls;

    if (firstTime === true || email.touched === true) {
      email = Validation.notNullValidator(email);
      email = Validation.emailValidator(email);
      email.valid = !(email.nullValue || email.invalidEmail);
      if (
        (firstTime && email.invalidEmail) ||
        (email.touched && email.valid === false)
      ) {
        email.showErrorMsg = true;
      } else {
        email.showErrorMsg = false;
      }
    }

    if (firstTime === true || phone.touched === true) {
      phone = Validation.notNullValidator(phone);
      phone = Validation.validatePhoneNumber(phone);
      phone.valid = !(phone.nullValue || phone.invalidPhone);
      if (
        (firstTime && phone.invalidPhone) ||
        (phone.touched && phone.valid === false)
      ) {
        phone.showErrorMsg = true;
      } else {
        phone.showErrorMsg = false;
      }
    }
    gst.valid = true;
    pan.valid = true;
    // if (firstTime === true || gst.touched === true) {
    //   gst = Validation.validateLength(gst, 15);
    //   gst.valid = !gst.invalidLength;
    //   if (
    //     (firstTime && gst.invalidLength) ||
    //     (gst.touched && gst.valid === false)
    //   ) {
    //     gst.showErrorMsg = true;
    //   } else {
    //     gst.showErrorMsg = false;
    //   }
    // }

    // if (firstTime === true || pan.touched === true) {
    //   pan = Validation.validateLength(pan, 10);
    //   pan.valid = !pan.invalidLength;
    //   if (
    //     (firstTime && pan.invalidLength) ||
    //     (pan.touched && pan.valid === false)
    //   ) {
    //     pan.showErrorMsg = true;
    //   } else {
    //     pan.showErrorMsg = false;
    //   }
    // }

    if (firstTime === true || wa.touched === true) {
      wa = Validation.notNullValidator(wa);
      wa = Validation.validatePhoneNumber(wa);
      wa.valid = !(wa.nullValue || wa.invalidPhone);
      if (
        (firstTime && wa.invalidPhone) ||
        (wa.touched && wa.valid === false)
      ) {
        wa.showErrorMsg = true;
      } else {
        wa.showErrorMsg = false;
      }
    }

    if (
      email.valid === true &&
      phone.valid === true &&
      wa.valid === true
    ) {
      isBusinessFormValid = true;
    } else {
      isBusinessFormValid = false;
    }
    this.setState({ controls, isBusinessFormValid });
  };

  /**
   * @param firstTime when form loads for first time directly error showing makes bad experience
   *            so do not show any message for null values but disable save button if
   *            there is something missing or some error.
   */
  contactFormValidation = (firstTime) => {
    // let firstTime = true;

    let { controls, isContactFormValid } = this.state;
    let {
      primaryPerson,
      primaryNumber,
      primaryEmail,
      primaryDesignation,
      primaryWa,
      // sameAsUser,
    } = controls;

    if (firstTime === true || primaryPerson.touched === true) {
      primaryPerson = Validation.notNullValidator(primaryPerson);
      primaryPerson.valid = !primaryPerson.nullValue; // it will be removed
      if (primaryPerson.touched && primaryPerson.valid === false) {
        primaryPerson.showErrorMsg = true;
      } else {
        primaryPerson.showErrorMsg = false;
      }
    }

    if (firstTime === true || primaryNumber.touched === true) {
      primaryNumber = Validation.validatePhoneNumber(primaryNumber);
      primaryNumber = Validation.notNullValidator(primaryNumber);
      primaryNumber.valid = !(
        primaryNumber.invalidPhone || primaryNumber.nullValue
      );
      if (
        (firstTime && primaryNumber.invalidPhone) ||
        (primaryNumber.touched && primaryNumber.valid === false)
      ) {
        primaryNumber.showErrorMsg = true;
      } else {
        primaryNumber.showErrorMsg = false;
      }
    }

    if (firstTime === true || primaryEmail.touched === true) {
      primaryEmail = Validation.notNullValidator(primaryEmail);
      primaryEmail = Validation.emailValidator(primaryEmail);
      primaryEmail.valid = !(
        primaryEmail.nullValue || primaryEmail.invalidEmail
      );
      if (
        (firstTime && primaryEmail.invalidEmail) ||
        (primaryEmail.touched && primaryEmail.valid === false)
      ) {
        primaryEmail.showErrorMsg = true;
      } else {
        primaryEmail.showErrorMsg = false;
      }
    }

    if (firstTime === true || primaryDesignation.touched === true) {
      primaryDesignation = Validation.notNullValidator(primaryDesignation);

      primaryDesignation.valid = !primaryDesignation.nullValue;
      if (primaryDesignation.touched && primaryDesignation.valid === false) {
        primaryDesignation.showErrorMsg = true;
      } else {
        primaryDesignation.showErrorMsg = false;
      }
    }

    if (firstTime === true || primaryWa.touched === true) {
      primaryWa = Validation.validatePhoneNumber(primaryWa);
      primaryWa = Validation.notNullValidator(primaryWa);
      primaryWa.valid = !(primaryWa.invalidPhone || primaryWa.nullValue);
      if (
        (firstTime && primaryWa.invalidPhone) ||
        (primaryWa.touched && primaryWa.valid === false)
      ) {
        primaryWa.showErrorMsg = true;
      } else {
        primaryWa.showErrorMsg = false;
      }
    }

    if (
      primaryPerson.valid === true &&
      primaryNumber.valid === true &&
      primaryDesignation.valid === true &&
      primaryWa.valid === true &&
      primaryEmail.valid === true
    ) {
      isContactFormValid = true;
    } else {
      isContactFormValid = false;
    }
    this.setState({ controls, isContactFormValid });
  };

  /**
   * @param firstTime when form loads for first time directly error showing makes bad experience
   *            so do not show any message for null values but disable save button if
   *            there is something missing or some error.
   */
  socialFormValidation = (firstTime) => {
    let { controls, isSocialFormValid } = this.state;
    const {
      birthDate,
      instagram,
      facebook,
      anniversaryDate,
      website,
    } = controls;

    if (firstTime === true || birthDate.touched === true) {
      if (
        birthDate.value === null ||
        birthDate.value === undefined ||
        birthDate.value === ""
      ) {
        birthDate.nullValue = true;
      } else {
        birthDate.nullValue = false;
      }

      birthDate.valid = !birthDate.nullValue;
    }

    if (firstTime === true || anniversaryDate.touched === true) {
      anniversaryDate.valid = !anniversaryDate.nullValue;
    }

    if (firstTime === true || facebook.touched === true) {
      facebook.valid = !facebook.nullValue;
    }

    if (firstTime === true || instagram.touched === true) {
      instagram.valid = !instagram.nullValue;
    }

    if (firstTime === true || website.touched === true) {
      // website = Validation.notNullValidator(website);
      website.valid = !website.nullValue;
      if (website.touched && website.valid === false) {
        website.showErrorMsg = true;
      } else {
        website.showErrorMsg = false;
      }
    }

    if (
      birthDate.valid === true &&
      anniversaryDate.valid === true &&
      facebook.valid === true &&
      instagram.valid === true &&
      website.valid === true
    ) {
      isSocialFormValid = true;
    } else {
      isSocialFormValid = false;
    }
    this.setState({ controls, isSocialFormValid });
  };

  handleUploadImage = (event) => {
    const file = event.target.files[0];
    this.setState({ isImageUpdating: true });
    const obj = {
      file,
    };

    if (this.state.fleet_id) {
      UserService.uploadImageProfile(this.state.fleet_id, obj)
        .then((data) => {
          this.props.isProfileUpdate(true);
          this.setState({
            profileImage: URL.createObjectURL(file),
            isImageUpdating: false,
          });
        })
        .catch((e) => {
          this.setState({
            profileImage: null,
            isImageUpdating: false,
          });
        });
    } else {
      UserService.uploadImage(obj)
        .then((data) => {
          this.props.isProfileUpdate(true);
          this.setState({
            profileImage: URL.createObjectURL(file),
            isImageUpdating: false,
          });
        })
        .catch((e) => {
          this.setState({
            profileImage: null,
            isImageUpdating: false,
          });
        });
    }
  };

  activeFragment = (fragment) => {
    //this.setState({ activeFragment: fragment });
  };

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    if (controlName === 'phone' || controlName === 'pin_code' ||
      controlName === 'mobile_number' || controlName === 'wa' || controlName === 'primaryNumber' ||
      controlName === 'primaryWa') {
      if (!isNaN(controlValue)) {
        controls[controlName].value = controlValue;
      }
    } else if (controlName === 'company_type') {
      if (e.target.value === 'proprietor') {
        controls.designation.value = 'owner';
      } else if (e.target.value === 'partnership') {
        controls.designation.value = 'partner';
      } else if (e.target.value === 'private limited') {
        controls.designation.value = 'director';
      } else if (e.target.value === 'limited') {
        controls.designation.value = 'director';
      }
      controls.company_type.value = controlValue;
      controls.designation.touched = true;
      controls.designation.showErrorMsg = false;
      //this.props.345(controls.designation.value);
    } else {
      controls[controlName].value = controlValue;
    }
    if (controlName === 'state') {
      controls.city.value = '';
    }
    controls[controlName].touched = true;
    this.setState({ controls }, () => {

      if (controlName === 'state') {

        if (this.childFleetBusinessDetail.current) {
          this.childFleetBusinessDetail.current.getCity(controlValue);
        }
      }
    });
    // this.handleValidation();

    if (this.state.activeFragment === 'business') {
      //this.businessFormValidation();
      this.handleValidationBusiness();
    }
    if (this.state.activeFragment === "contact") {
      this.contactFormValidation();
    }
    if (this.state.activeFragment === "social") {
      this.socialFormValidation();
    }
    this.handleValidationBusiness();
    this.handleValidationPrimary();
    this.contactFormValidation();
    this.socialFormValidation();
  }

  handleValidationBusiness = (isSubmit = false) => {
    let { controls } = this.state;
    let isValidForm = false;
    let { company_name, company_type, owner_name, phone, state,
      // designation,
      mobile_number, wa,
      city, gst, pan, address, pin_code, email
    } = controls;
    if (company_name.touched === true || isSubmit) {
      company_name = Validation.notNullValidator(company_name);
      company_name.valid = !company_name.nullValue;
      if (company_name.valid === false) {
        company_name.showErrorMsg = true;
      } else {
        company_name.showErrorMsg = false;
      }
    }

    if (company_type.touched === true || isSubmit) {
      company_type = Validation.notNullValidator(company_type);
      company_type.valid = !company_type.nullValue;
      if (company_type.valid === false) {
        company_type.showErrorMsg = true;
      } else {
        company_type.showErrorMsg = false;
      }
    }


    if (owner_name.touched === true || isSubmit) {
      owner_name = Validation.notNullValidator(owner_name);
      owner_name.valid = !owner_name.nullValue;
      if (owner_name.valid === false) {
        owner_name.showErrorMsg = true;
      } else {
        owner_name.showErrorMsg = false;
      }
    }

    // if (designation.touched === true || isSubmit) {
    //   designation = Validation.notNullValidator(designation);
    //   designation.valid = !designation.nullValue;
    //   if (designation.valid === false) {
    //     designation.showErrorMsg = true;
    //   } else {
    //     designation.showErrorMsg = false;
    //   }
    // }

    if (state.touched === true || isSubmit) {
      state = Validation.notNullValidator(state);
      state.valid = !state.nullValue;
      if (state.valid === false) {
        state.showErrorMsg = true;
      } else {
        state.showErrorMsg = false;
      }
    }


    if (city.touched === true || isSubmit) {
      city = Validation.notNullValidator(city);
      city.valid = !city.nullValue;
      if (city.valid === false) {
        city.showErrorMsg = true;
      } else {
        city.showErrorMsg = false;
      }
    }

    if (address.touched === true || isSubmit) {
      address = Validation.notNullValidator(address);
      address.valid = !address.nullValue;
      if (address.valid === false) {
        address.showErrorMsg = true;
      } else {
        address.showErrorMsg = false;
      }
    }

    if (pin_code.touched === true || isSubmit) {
      pin_code = Validation.notNullValidator(pin_code);
      pin_code = Validation.validateLength(pin_code, 6);
      pin_code.valid = !(pin_code.invalidLength || pin_code.nullValue);
      if (pin_code.valid === false) {
        pin_code.showErrorMsg = true;
      } else {
        pin_code.showErrorMsg = false;
      }
    }

    if (mobile_number.touched === true || isSubmit) {

      mobile_number = Validation.notNullValidator(mobile_number);
      mobile_number = Validation.validatePhoneNumber(mobile_number);
      mobile_number = Validation.validateLength(mobile_number, 10);
      mobile_number.valid = !(mobile_number.invalidPhone || mobile_number.nullValue || mobile_number.invalidLength);
      if (mobile_number.valid === false) {
        mobile_number.showErrorMsg = true;
      } else {
        mobile_number.showErrorMsg = false;
      }
    }

    if (wa.touched === true || isSubmit) {
      wa = Validation.notNullValidator(wa);
      wa = Validation.validatePhoneNumber(wa);
      wa = Validation.validateLength(wa, 10);
      wa.valid = !(wa.invalidPhone || wa.nullValue ||
        wa.invalidLength);
      if (wa.valid === false) {
        wa.showErrorMsg = true;
      } else {
        wa.showErrorMsg = false;
      }
    }

    if (phone.touched === true || isSubmit) {
      phone = Validation.notNullValidator(phone);
      phone = Validation.validatePhoneNumber(phone);
      // phone = Validation.validateLength(phone, 11);
      phone.valid = !(phone.invalidPhone || phone.nullValue ||
        phone.invalidLength);
      if (phone.valid === false) {
        phone.showErrorMsg = true;
      } else {
        phone.showErrorMsg = false;
      }
    }

    // if ((gst.touched === true || isSubmit)) {
    //   gst = Validation.notNullValidator(gst);
    //   if (!gst.nullValue) {
    //     gst.value = gst.value.toUpperCase();
    //   }
    //   gst = Validation.validateGST(gst);
    //   gst.valid = !(gst.invalidGST || gst.nullValue);
    //   if (gst.valid === false) {
    //     gst.showErrorMsg = true;
    //   } else {
    //     gst.showErrorMsg = false;
    //   }
    // }

    // if ((pan.touched === true || isSubmit)) {
    //   pan = Validation.notNullValidator(pan);
    //   pan = Validation.validatePAN(pan);
    //   //pan = Validation.validateLength(pan, 10);
    //   pan.valid = !(pan.invalidPAN || pan.nullValue);
    //   if (pan.valid === false) {
    //     pan.showErrorMsg = true;
    //   } else {
    //     pan.showErrorMsg = false;
    //   }
    // }
    gst.valid = true;
    pan.valid = true;
    if ((email.touched === true || isSubmit)) {
      email = Validation.notNullValidator(email);
      email = Validation.emailValidator(email);
      email.valid = !(email.nullValue || email.invalidEmail);
      if (email.valid === false) {
        email.showErrorMsg = true;
      } else {
        email.showErrorMsg = false;
      }
    }

    if (
      email.valid === true &&
      company_name.valid === true &&
      company_type.valid === true &&
      owner_name.valid === true &&
      state.valid === true &&
      city.valid === true &&
      mobile_number.valid === true &&
      wa.valid === true &&
      phone.valid === true &&
      address.valid === true &&
      pin_code.valid === true
    ) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }

    this.setState({ controls, isValidForm });
    return isValidForm;
  }
  toCamelCase = (str) => {
    if (str) {
      str = str ? str.toString() : '';
      str = str.split(" ");

      for (var i = 0, x = str.length; i < x; i++) {
        str[i] = str[i][0].toUpperCase() + str[i].substr(1);
      }

      return str.join(" ");
    }
    return str;
  }

  handleBusinessSave = () => {
    if (!this.handleValidationBusiness(true)) {
      return
    }
    let { controls, businessCardObj, businessName, ownerName, address, all_mandtory_error } = this.state;
    const { email, phone, gst, pan, wa } = controls;
    // const arr = businessCardObj.fields;

    const obj = {
      company_name: controls.company_name.value,
      company_type: controls.company_type.value,
      owner_name: controls.owner_name.value,
      mobile_number: controls.mobile_number.value,
      // email: controls.email.value,
      address: controls.address.value,
      state: controls.state.value ? this.toCamelCase(controls.state.value) : '',
      city: controls.city.value ? this.toCamelCase(controls.city.value) : '',
      pin_code: controls.pin_code.value,
      'designation': controls.designation.value,
      'email': email.value,
      'phoneNumber': phone.value, // only numbers
      'gstNumber': gst.value ? gst.value.toUpperCase() : null, // 15 digit
      'panNumber': pan.value ? pan.value.toUpperCase() : null, // 10 digit
      'whatsappNumberUser': wa.value,
      fleet_id: this.state.fleet_id
    };

    if (this.childFleetBusinessDetail.current) {
      this.childFleetBusinessDetail.current.setLoading(true);
    }
    UserService.updateUserInfo(obj)
      .then(data => {
        if (this.childFleetBusinessDetail.current) {
          this.childFleetBusinessDetail.current.setLoading(false);
        }
        const userData = data.data.data;
        this.props.setUserDetail(userData);
        let businessFields = businessCardObj.fields;
        businessFields[0].value = userData.company_name;
        businessFields[1].value = userData.owner_name;
        businessFields[2].value = userData.company_type;
        businessFields[3].value = userData.designation;
        businessFields[4].value = userData.mobile_number;

        businessFields[5].value = userData.whats_app_number_user;
        businessFields[6].value = userData.telephone_no_1;
        businessFields[7].value = userData.email_1;
        businessFields[8].value = userData.gst_number ? userData.gst_number : '';
        businessFields[9].value = userData.pan_number;
        businessFields[10].value = userData.address;
        businessFields[11].value = userData.state;
        businessFields[12].value = userData.city;
        businessFields[13].value = userData.pin_code;
        businessName = userData.business_name;
        ownerName = userData.owner_name;
        address = userData.address;
        all_mandtory_error.is_business = false;
        this.setState({
          businessCardObj, isBusinessEditActive: false, uDetail: userData,
          businessName, ownerName, address
        }, () => {

        });
      })
      .catch(e => {
        if (this.childFleetBusinessDetail.current) {
          this.childFleetBusinessDetail.current.setLoading(false);
        }
      });
  }


  handleCommuncationSave = () => {
    let controlsNewFleetCommunicationDetail = this.childNewFleetCommunicationDetail.current.state.controls;
    const obj = {
      "communication_address": controlsNewFleetCommunicationDetail.communication_address.value,
      "communication_state": controlsNewFleetCommunicationDetail.communication_state.value,
      "communication_city": controlsNewFleetCommunicationDetail.communication_city.value,
      "communication_pin_code": controlsNewFleetCommunicationDetail.communication_pin_code.value,
      fleet_id: this.state.fleet_id
    };

    if (this.childNewFleetCommunicationDetail.current) {
      this.childNewFleetCommunicationDetail.current.setLoading(true);
    }
    UserService.updateUserInfo(obj)
      .then(data => {

        if (this.childNewFleetCommunicationDetail.current) {
          this.childNewFleetCommunicationDetail.current.setLoading(false);
        }
        const userData = data.data.data;
        this.props.setUserDetail(userData);
        if (this.childNewFleetCommunicationDetail.current) {
          this.childNewFleetCommunicationDetail.current.setFleetDetail(userData);
        }
        let { all_mandtory_error } = this.state;
        all_mandtory_error.is_communication = false;
        this.setState((prevState) => {
          return {
            ...prevState,
            uDetail: userData,
            isCommuncationEditActive: false,
            all_mandtory_error
          };
        }, () => {
        });
      })
      .catch(e => {

        if (this.childNewFleetCommunicationDetail.current) {
          this.childNewFleetCommunicationDetail.current.setLoading(false);
        }
      });
  }


  handlePersonalDetailSave = () => {
    let controlsNewFleetPersonalDetails = this.childNewFleetPersonalDetails.current.state.controls;
    const obj = {
      "home_address": controlsNewFleetPersonalDetails.home_address.value,
      "birthDate": controlsNewFleetPersonalDetails.birth_date.value,
      "educational_qualification": controlsNewFleetPersonalDetails.education_qualification.value,
      "languages": [],
      "marital_status": controlsNewFleetPersonalDetails.marital_status.value,
      "anniversary_date": controlsNewFleetPersonalDetails.marital_status.value === 'married' ? controlsNewFleetPersonalDetails.anniversary_date.value : null,
      "spouse_name": controlsNewFleetPersonalDetails.marital_status.value === 'married' ? controlsNewFleetPersonalDetails.spouse_name.value : null,
      "spouse_date_of_birth": controlsNewFleetPersonalDetails.marital_status.value === 'married' ? controlsNewFleetPersonalDetails.spouse_dob.value : null,
      "child_1_name": controlsNewFleetPersonalDetails.marital_status.value === 'married' && controlsNewFleetPersonalDetails.isAddChild.value ? controlsNewFleetPersonalDetails.child_1_name.value : null,
      "child_1_date_of_birth": controlsNewFleetPersonalDetails.marital_status.value === 'married' && controlsNewFleetPersonalDetails.isAddChild.value ? controlsNewFleetPersonalDetails.child_1_dob.value : null,
      "child_2_name": controlsNewFleetPersonalDetails.marital_status.value === 'married' && controlsNewFleetPersonalDetails.isAddChild.value ? controlsNewFleetPersonalDetails.child_2_name.value : null,
      "child_2_date_of_birth": controlsNewFleetPersonalDetails.marital_status.value === 'married' && controlsNewFleetPersonalDetails.isAddChild.value ? controlsNewFleetPersonalDetails.child_2_dob.value : null,
      fleet_id: this.state.fleet_id
    };
    if (controlsNewFleetPersonalDetails.languages.value && controlsNewFleetPersonalDetails.languages.value.length > 0) {
      controlsNewFleetPersonalDetails.languages.value.forEach(element => {
        obj.languages.push(element.label);
      });
    }
    if (this.childNewFleetPersonalDetails.current) {
      this.childNewFleetPersonalDetails.current.setLoading(true);
    }
    UserService.updateUserInfo(obj)
      .then(data => {
        const userData = data.data.data;
        if (this.childNewFleetPersonalDetails.current) {
          this.childNewFleetPersonalDetails.current.setLoading(false);
          if (userData.child_1_date_of_birth) {
            userData.child_1_dob = userData.child_1_date_of_birth;
          }
          if (userData.child_2_date_of_birth) {
            userData.child_2_dob = userData.child_2_date_of_birth;
          }
          if (userData.spouse_date_of_birth) {
            userData.spouse_dob = userData.spouse_date_of_birth;
          }
          if (userData.educational_qualification) {
            userData.education_qualification = userData.educational_qualification;
          }
          this.childNewFleetPersonalDetails.current.setFleetDetail(userData);
        }
        let { all_mandtory_error } = this.state;
        all_mandtory_error.is_personal = false;
        this.props.setUserDetail(userData);
        this.setState((prevState) => {
          return {
            ...prevState,
            uDetail: userData,
            isPersonalDetailEditActive: false,
            all_mandtory_error
          };
        });
      })
      .catch(e => {
        if (this.childNewFleetPersonalDetails.current) {
          this.childNewFleetPersonalDetails.current.setLoading(false);
        }
      });
  }

  handleValidationPrimary = (isSubmit = false) => {
    let { controls } = this.state;
    let isValidForm = false;
    let { primaryPerson, primaryDesignation, primaryNumber, primaryWa, primaryEmail } = controls;
    if (primaryPerson.touched === true || isSubmit) {
      primaryPerson = Validation.notNullValidator(primaryPerson);
      primaryPerson.valid = !primaryPerson.nullValue;
      if (primaryPerson.valid === false) {
        primaryPerson.showErrorMsg = true;
      } else {
        primaryPerson.showErrorMsg = false;
      }
    }
    if (primaryDesignation.touched === true || isSubmit) {
      primaryDesignation = Validation.notNullValidator(primaryDesignation);
      primaryDesignation.valid = !primaryDesignation.nullValue;
      if (primaryDesignation.valid === false) {
        primaryDesignation.showErrorMsg = true;
      } else {
        primaryDesignation.showErrorMsg = false;
      }
    }

    if (primaryNumber.touched === true || isSubmit) {
      primaryNumber = Validation.notNullValidator(primaryNumber);
      primaryNumber = Validation.validatePhoneNumber(primaryNumber);
      primaryNumber = Validation.validateLength(primaryNumber, 10);
      primaryNumber.valid = !(primaryNumber.invalidPhone || primaryNumber.nullValue || primaryNumber.invalidLength);
      if (primaryNumber.valid === false) {
        primaryNumber.showErrorMsg = true;
      } else {
        primaryNumber.showErrorMsg = false;
      }
    }

    if (primaryWa.touched === true || isSubmit) {
      primaryWa = Validation.notNullValidator(primaryWa);
      primaryWa = Validation.validatePhoneNumber(primaryWa);
      primaryWa = Validation.validateLength(primaryWa, 10);
      primaryWa.valid = !(primaryWa.invalidPhone || primaryWa.nullValue ||
        primaryWa.invalidLength);
      if (primaryWa.valid === false) {
        primaryWa.showErrorMsg = true;
      } else {
        primaryWa.showErrorMsg = false;
      }
    }



    if ((primaryEmail.touched === true || isSubmit)) {
      primaryEmail = Validation.notNullValidator(primaryEmail);
      primaryEmail = Validation.emailValidator(primaryEmail);
      primaryEmail.valid = !(primaryEmail.nullValue || primaryEmail.invalidEmail);
      if (primaryEmail.valid === false) {
        primaryEmail.showErrorMsg = true;
      } else {
        primaryEmail.showErrorMsg = false;
      }
    }

    if (primaryWa.valid === true &&
      primaryEmail.valid === true &&
      primaryNumber.valid === true &&
      primaryPerson.valid === true
    ) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }
    this.setState({ controls });
    return isValidForm;
  }

  handleContactSave = () => {
    if (!this.handleValidationPrimary(true)) {
      return false;
    }
    const { controls, contactCardObj, all_mandtory_error } = this.state;
    const {
      primaryPerson,
      primaryDesignation,
      primaryNumber,
      primaryWa,
      primaryEmail,
    } = controls;
    const arr = contactCardObj.fields;

    const obj = {
      'alternateContactPerson': primaryPerson.value,
      'alternateContactNumber': primaryNumber.value,
      'alternate_designation': primaryDesignation.value,
      'whatsappNumber': primaryWa.value,
      'alternateContactEmail': primaryEmail.value,
      fleet_id: this.state.fleet_id
    };
    if (this.childPrimaryContact.current) {
      this.childNewFleetCommunicationDetail.current.setLoading(true);
    }
    UserService.updateUserInfo(obj)
      .then(data => {
        if (this.childPrimaryContact.current) {
          this.childNewFleetCommunicationDetail.current.setLoading(false);
        }
        const userData = data.data.data;
        this.props.setUserDetail(userData);
        arr[0].value = primaryPerson.value;
        arr[1].value = primaryNumber.value;
        arr[2].value = primaryEmail.value;
        arr[3].value = primaryWa.value;
        arr[4].value = primaryDesignation.value;
        all_mandtory_error.is_primary = false;
        this.setState({ contactCardObj, uDetail: userData, isContactEditActive: false, all_mandtory_error });
      })
      .catch(e => {
        if (this.childPrimaryContact.current) {
          this.childNewFleetCommunicationDetail.current.setLoading(false);
        }
      });
  }

  handleSocialSave = () => {
    let { controls, socialCardObj, bDayMaster, aDayMaster } = this.state;
    const {
      // birthDate,
      // anniversaryDate,
      facebook,
      instagram,
      website,
    } = controls;
    const arr = socialCardObj.fields;

    const obj = {
      'facebookUrl': facebook.value,
      'instagramUrl': instagram.value,
      'website': website.value,
      fleet_id: this.state.fleet_id
    };

    UserService.updateUserInfo(obj)
      .then((data) => {
        const userData = data.data.data;
        this.props.setUserDetail(userData);

        arr[0].value = userData.facebook_url;
        arr[1].value = userData.instagram_url;
        arr[2].value = userData.website;
        this.setState({ socialCardObj, isSocialEditActive: false, aDayMaster, uDetail: userData, bDayMaster });
      })
      .catch((e) => { });
  };

  handleFleetSave = (inputName) => {
    const { controls } = this.state;
    // const { birthDate, anniversaryDate, facebook, instagram, website } = controls;
    // const arr = socialCardObj.fields;
    const obj = {
      fleet_id: this.state.fleet_id
    };
    obj[inputName] = controls[inputName].value;

    UserService.updateUserInfo(obj)
      .then((data) => {
        const userData = data.data.data;
        this.props.setUserDetail(userData);
        this.makeEditActiveFleet(inputName, false);
        // this.setState({ socialCardObj, isSocialEditActive: false, aDayMaster, bDayMaster });
      })
      .catch((e) => { });
  };

  handleBusinessCancel = () => {
    const { controls,
      // businessCardObj, 
      uDetail } = this.state;
    const { email, phone, gst, pan, wa } = controls;
    // const arr = businessCardObj.fields;
    controls.owner_name.value = uDetail.owner_name;
    controls.company_name.value = uDetail.company_name;
    controls.company_type.value = uDetail.company_type;
    controls.designation.value = uDetail.designation;
    controls.mobile_number.value = uDetail.mobile_number;
    controls.address.value = uDetail.address;
    controls.state.value = uDetail.state;
    if (this.childFleetBusinessDetail.current) {
      this.childFleetBusinessDetail.current.getCity(controls.state.value);
    }

    controls.city.value = uDetail.city;
    controls.pin_code.value = uDetail.pin_code;
    email.value = uDetail.email_1;
    phone.value = uDetail.telephone_no_1;
    // phone.value = null;
    gst.value = uDetail.gst_number;
    pan.value = uDetail.pan_number;
    wa.value = uDetail.whats_app_number_user;
    this.setState({
      controls
    })

  }

  handleContactCancel = () => {
    const { controls, contactCardObj, uDetail } = this.state;
    const { primaryPerson, primaryDesignation, primaryNumber, primaryWa, primaryEmail } = controls;
    let arr = contactCardObj.fields;

    primaryPerson.value = arr[0].value;
    primaryNumber.value = arr[1].value;
    primaryEmail.value = arr[2].value;
    primaryWa.value = arr[3].value;
    primaryDesignation.value = arr[4].value;

    arr[0].value = uDetail.alternate_contact_person;
    arr[1].value = uDetail.alternate_contact_number;
    arr[2].value = uDetail.alternate_contact_email;
    arr[3].value = uDetail.whats_app_number;
    arr[4].value = uDetail.alternate_designation;
    arr.sameAsUser = false;

    this.setState({ controls, contactCardObj }, () => {
      this.contactFormValidation();
    });
  }

  handleSocialCancel = () => {
    const { controls, socialCardObj } = this.state;
    const {
      facebook,
      instagram,
      website,
    } = controls;
    const arr = socialCardObj.fields;
    facebook.value = arr[0].value;
    instagram.value = arr[1].value;
    website.value = arr[2].value;
  }

  makeEditActive = (frg, status) => {
    const st = this.state;
    st[frg] = status;
    let { communcationCardObj } = this.state;
    if (status === false) {
      if (frg === "isBusinessEditActive") {
        this.handleBusinessCancel();
      } else if (frg === "isContactEditActive") {
        this.handleContactCancel();
      } else if (frg === "isSocialEditActive") {
        this.handleSocialCancel();
      } else if (frg === 'isSocialEditActive') {
        this.handleSocialCancel();
      }
    }
    this.setState({ st, communcationCardObj }, () => {
      // let { controls } = this.state;
      if (status === true) {
        if (frg === 'isBusinessEditActive') {
          this.handleBusinessCancel();
          // if (controls.state.value) {
          //   this.childFleetBusinessDetail.current.getCity(controls.state.value);
          // }
        }
      }
    });
  }

  handleBirthDateChange = (e) => {
    const { controls } = this.state;
    const { birthDate } = controls;
    birthDate.value = e;
    birthDate.touched = true;
    this.setState({ controls });
    this.socialFormValidation();
  };

  handleAnniversaryDateChange = (e) => {
    const { controls } = this.state;
    const { anniversaryDate } = controls;
    anniversaryDate.value = e;
    anniversaryDate.touched = true;
    this.setState({ controls });
    // this.handleValidation();
  };

  setSameAsUserCheckBoxValue = () => {
    const { controls, ownerName } = this.state;
    const {
      primaryPerson,
      primaryNumber,
      primaryDesignation,
      primaryEmail,
      primaryWa,
      // phone,
      email,
      wa,
    } = controls;
    // const { agreeTermAndCondition } = controls;
    controls.sameAsUser = !controls.sameAsUser;
    if (controls.sameAsUser === true) {
      primaryPerson.value = ownerName;
      primaryPerson.touched = true;
      primaryNumber.value = controls.mobile_number.value;
      primaryNumber.touched = true;
      primaryDesignation.value = controls.designation.value;
      primaryDesignation.touched = true;
      primaryEmail.value = email.value;
      primaryEmail.touched = true;
      primaryWa.value = wa.value;
      primaryWa.touched = true;
    } else {
      primaryPerson.value = '';
      //      primaryPerson.touched = true;
      primaryNumber.value = '';
      //primaryNumber.touched = true;
      primaryDesignation.value = '';
      //primaryDesignation.touched = true;
      primaryEmail.value = '';
      //primaryEmail.touched = true;
      primaryWa.value = '';
      //primaryWa.touched = true;
    }
    this.setState({ controls });
    this.contactFormValidation();
  };

  formatDate = (d) => {
    const dateString = new Date(d).toLocaleString();
    const dateSplit = dateString.split(",");
    const date = dateSplit[0];
    return date;
  };

  updateReqButton = (update) => {
    this.setState({ isUpdateProfileRequestSend: update });
  };

  makeEditActiveFleet = (controlName, value) => {
    const { controls } = this.state;
    controls[controlName].isEditActive = value;
    this.setState({ controls });
  };

  onSetSidebarOpen = (open) => {
    document.body.style.overflow = "hidden";
    this.dynamicAddEditSubsidiaries();
    this.setState((prevState) => {
      return {
        ...prevState,
        isDisplaySubsidiariesConfirmModal: true,
        sidebarOpen: open,
        isAddSubsidiaries: true,
        editSubsidiariesIndex:
          this.stateAddEditSubsidiaries.addEditSubsidiaries.length - 1,
      };
    });
    setTimeout(() => {
      if (
        Object.keys(this.refs).length > 0 &&
        this.refs &&
        this.refs.childAddEditSubsidiaries
      ) {
        this.refs.childAddEditSubsidiaries.setValue();
      }
    }, 1);
  };

  removeSubsidiaries = (id) => {
    AddEditSubsidiariesService.deleteSubsidiaries({ id })
      .then((response) => {
        // debugger;
        document.body.style.overflow = "auto";
        swal(
          "Deleted Subsidiary",
          messages.ADD_EDIT_SUBSIDIARIES.SUCCESS_DELETED_SUBSIDIARIES,
          "success"
        );
        this.getSubsidiaries();
      })
      .catch((e) => {
        if (
          e.response &&
          e.response.data &&
          e.response.data.error &&
          e.response.data.error.length > 0
        ) {
          swal("", e.response.data.error[0].message, "error");
        }
      });
  };

  editSubsidiaries = (index) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        sidebarOpen: true,
        editSubsidiariesIndex: index,
        isAddSubsidiaries: false,
      };
    });
    setTimeout(() => {
      if (
        Object.keys(this.refs).length > 0 &&
        this.refs &&
        this.refs.childAddEditSubsidiaries
      ) {
        this.refs.childAddEditSubsidiaries.setEditData(index);
      }
    }, 1);
  };

  onCloseSidebar = () => {
    document.body.style.overflow = "auto";
    this.getSubsidiaries();
    this.setState((prevState) => {
      return { ...prevState, sidebarOpen: false };
    });
  };

  addSubsidiaries = () => {
    this.getSubsidiaries();
    this.onCloseSidebar();
  };

  buildMyFleetClick = (flag) => {
    if (!flag) {
      this.getFleetData();
    }
    this.setState({ showBuildMyFleet: flag });
  }

  openAddEditVehicle = (type, isAddVehicleDetail) => {
    let { isOpenAddEditVehicle } = this.state;
    this.setState({
      isOpenAddEditVehicle: !isOpenAddEditVehicle,
      addEditVehicleType: type,
      isAddVehicleDetail: isAddVehicleDetail
    });
  }

  closeSideBarAddEditVehicle = () => {
    let { isOpenAddEditVehicle } = this.state;
    this.setState({
      isOpenAddEditVehicle: !isOpenAddEditVehicle
    })
  }

  submitVehclies = (data) => {
    let { vehicleData } = this.state;
    if (Object.keys(data).length > 0) {
      vehicleData = data;
    } else {
      vehicleData = {};
    }
    this.setState({
      vehicleData: vehicleData,
      isOpenAddEditVehicle: false
    })
    this.getFleetData();
    this.getBusinessRelatedDetail();
    //this.scrollTo('VehicleDetail');
  }

  deleteFleet = async (fleetId, totalTyre, vehicle_type) => {
    try {
      this.setState({ isLoading: true });
      const { data } = await FleetService.deleteFleet({ fleetId, totalTyre });
      if (data.message) {
        ModalService.openAlert(data.message, '', 'success');
        this.getFleetData();
        this.getBusinessRelatedDetail();
        if (vehicle_type !== 'retread') {
          this.refs.refVehicleDetail.deletBiasRadial(vehicle_type);
        }
      }
      this.setState({ isLoading: false });
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
        ModalService.openAlert(e.response.data.error[0].message, '', 'error');
      }
      this.setState({ isLoading: false });
      console.log(e);
    }
  }

  async getFleetData() {
    let { fleetData } = this.state;

    try {
      this.setState({
        isLoading: true
      })

      const { data } = await FleetService.getFleetDataProfile(this.state.fleet_id);
      if (data) {
        fleetData = data.data;
        this.setState({ fleetData: data.data });

        // let businessRelatedDetail = {
        //   truck: [],
        //   bus: [],
        //   lcv: [],
        //   scv: [],
        //   icv: [],
        //   pickup: []
        // };

        let totalCountBus = 0, totalCountTruck = 0, totalCountLcv = 0,
          totalCountScv = 0, totalCountIcv = 0, totalCountPickup = 0, totalCountRetread = false,
          totalWheelTruck = 0,
          totalWheelBus = 0,
          totalWheelSCV = 0,
          totalWheelLCV = 0,
          totalWheelICV = 0,
          totalWheelPickup = 0;
        data.data.forEach(element => {
          let count = 0;
          if (element.type.toLowerCase() === 'retread') {
            count = element.data[0].number_of_tyres_vehicle_count.tyres_per_month;
          }
          if (element.type.toLowerCase() === 'truck') {
            totalCountTruck = element.total_vehical;
            totalWheelTruck = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'bus') {
            totalCountBus = element.total_vehical;
            totalWheelBus = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'scv') {
            totalCountScv = element.total_vehical;
            totalWheelSCV = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'lcv') {
            totalCountLcv = element.total_vehical;
            totalWheelLCV = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'icv') {
            totalCountIcv = element.total_vehical;
            totalWheelICV = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'pickup') {
            totalCountPickup = element.total_vehical;
            totalWheelPickup = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'retread') {
            totalCountRetread = true;
          }
        });
        this.refs.refCountVehicleDetail.setData({
          totalCountBus: totalCountBus,
          totalCountTruck: totalCountTruck,
          totalCountLcv: totalCountLcv,
          totalCountScv: totalCountScv,
          totalCountIcv: totalCountIcv,
          totalCountPickup: totalCountPickup,
          totalCountRetread: totalCountRetread,
          totalWheelTruck: totalWheelTruck,
          totalWheelBus: totalWheelBus,
          totalWheelSCV: totalWheelSCV,
          totalWheelLCV: totalWheelLCV,
          totalWheelICV: totalWheelICV,
          totalWheelPickup: totalWheelPickup,
        });
        this.refs.refVehicleDetail.setData({
          totalCountBus: totalCountBus,
          totalCountTruck: totalCountTruck,
          totalCountLcv: totalCountLcv,
          totalCountScv: totalCountScv,
          totalCountIcv: totalCountIcv,
          totalCountPickup: totalCountPickup,
          totalCountRetread: totalCountRetread,
          totalWheelTruck: totalWheelTruck,
          totalWheelBus: totalWheelBus,
          totalWheelSCV: totalWheelSCV,
          totalWheelLCV: totalWheelLCV,
          totalWheelICV: totalWheelICV,
          totalWheelPickup: totalWheelPickup,
        });
      }
      // this.setState({ fleetData, isLoading: false });
      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({
        isLoading: false
      })
      console.log(error);
    }
  }

  deleteFleetVehicle = (vehicle_type) => {
    swal({
      title: "",
      text: "Are you sure, you want to delete vehicle detail ?",
      icon: "warning",
      buttons: ["No", "Yes"]
    }).then(isConfirm => {
      if (isConfirm) {
        let { fleetData } = this.state;
        let index = fleetData.findIndex(element => element.type.toLowerCase() === vehicle_type);
        if (index > -1) {
          this.deleteFleet(fleetData[index].data[0].fleet_id, fleetData[index].data[0].total_tyre, vehicle_type);
        }
      }
    });
  }

  async getBusinessRelatedDetail() {
    let { business_related_detail_data } = this.state;
    try {
      const { data } = await FleetService.getBusinessRelatedDetailsProfile(this.state.fleet_id);
      if (data.data && Object.keys(data.data).length > 0) {
        business_related_detail_data = data.data;
      } else {
        business_related_detail_data = {};
      }
      if (this.refs.refVehicleDetail) {
        this.refs.refVehicleDetail.setFleetDetail(business_related_detail_data);
      }
      this.setState({
        business_related_detail_data
      })
    } catch (error) {
      console.log(error);
      this.setState({ isLoading: false });
    }

  }

  updateTruckBusData = (params) => {
    const { controls } = this.state;
    const { truck, bus } = controls;
    truck.value = params.truck.value;
    bus.value = params.bus.value;
    this.setState({ controls });
  };

  openFleetdeatil = () => {
    this.props.history.push(`/fleetDetails`);
  }

  getUserPopupTitles = () => {
    SpecialEngagementService.getPopupTitles()
      .then((data) => {
        const titles = data.data.data;
        this.setState({ popupTitles: titles });
      })
      .catch((e) => {
        console.error("e", e);
      });
  };

  openActionSidebar = () => {
    window.scroll(0, 0);
    this.setState({ isActionPageOpen: true });
  };

  closeActionSidebar = () => {
    this.setState({ isActionPageOpen: false });
  };



  refresh_state = () => {
    this.setState((prevState) => {
      return {
        ...prevState
      };
    });
  }

  updateBaadshsaCategory = async () => {
    try {
      const { data } = await FleetService.updateBaadshsaCategory();
      if (data.success) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
    }
  }
  updateProfile = async () => {

    if (!this.checkAllMandtoryFields()) {
      return
    }
    if (!this.refs.refCountVehicleDetail.handleValition()) {
      return;
    }
    // if (!this.refs.refVehicleDetail.checkAllDataValidationFront()) {
    //   return;
    // }

    // let invalidCountError = await this.updateBusinessRelatedDetails();
    // if (invalidCountError.truck.isInValid || invalidCountError.bus.isInValid || invalidCountError.lcv.isInValid ||
    //   invalidCountError.scv.isInValid || invalidCountError.icv.isInValid || invalidCountError.pickup.isInValid) {
    //   return
    // }

    swal('', 'Fleet data update successfully.', 'success').then((value) => {
      if (this.state.fleet_id) {
        this.props.history.push(
          `/fleetDetails`
        );
      } else {
        this.props.history.push(
          `/dashboard`
        );
      }
    });
  }
  proceedToUpdateBusinessRelatedDetail = async (obj) => {

    try {
      this.setState({
        isLoading: true
      })
      // const { data } = await FleetService.updateBusinessRelatedDetails(obj);
      obj.f_id = this.state.fleet_id;

      let data;
      if (this.state.fleet_id) {
        data = await FleetService.updateBusinessRelatedDetailsProfile(obj);
      } else {
        data = await FleetService.updateBusinessRelatedDetails(obj);
      }
      data = data.data;

      this.setState({
        isLoading: false
      })
      if (data.success) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      this.setState({
        isLoading: false
      })
      return e.response.data.error[0].message;
    }
  }

  updateBusinessRelatedDetails = async () => {
    if (this.refs.refVehicleDetail && this.refs.refVehicleDetail.state) {
      let frontRearData = this.refs.refVehicleDetail.state.frontRearData;
      // let bias_radial_tyres = this.refs.refVehicleDetail.state.controls.bias_radial_tyres;
      let resFrontData = {
        bus: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          bias_radial_count: {},
          business_related_detail: []
        },
        truck: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          bias_radial_count: {},
          business_related_detail: []
        },
        lcv: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        },
        scv: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        },
        icv: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        },
        pickup: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        }
      };
      if (frontRearData && Object.keys(frontRearData).length > 0) {
        Object.keys(frontRearData).forEach((key, i) => {
          frontRearData[key].forEach(element => {
            if (element.fleet_id) {
              resFrontData[key].fleet_id = element.fleet_id;
            }
            if (element.temp_id) {
              resFrontData[key].temp_id = element.temp_id;
            }
            if (element.vehicle_type_id) {
              resFrontData[key].vehicle_type_id = element.vehicle_type_id;
            }
            if (element.vehicle_type.value) {
              resFrontData[key].vehicle_type = element.vehicle_type.value;
            }

            let brand = element.brand.value;
            if (element.brand.value && element.brand.value.toLowerCase() === 'jk tyre') {
              brand = "JK Tyre";
            } else if (element.brand.value && element.brand.value.toLowerCase() === 'vikrant') {
              brand = "Vikrant";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'apollo') {
              brand = "Apollo";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'mrf') {
              brand = "Mrf";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'ceat') {
              brand = "Ceat";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'contil') {
              brand = "Contil";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'birla') {
              brand = "Birla";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'bkt') {
              brand = "Bkt";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'bridgestone') {
              brand = "Bridgestone";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'chalanger') {
              brand = "Chalanger";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'michelin') {
              brand = "Michelin";
            }
            resFrontData[key].business_related_detail.push({
              construction: element.construction.value,
              size: element.size.value,
              brand: brand,
              pattren: element.pattren.value,
              tyres: element.tyres.value ? parseInt(element.tyres.value) : 0,
              brand_id: element.brand_id.value ? element.brand_id.value : '',
              type: element.type.value ? element.type.value : ''
            })
          });
        });
      }
      let invalidCountError = {
        truck: {
          message: '',
          isInValid: false
        },
        bus: {
          message: '',
          isInValid: false
        },
        lcv: {
          message: '',
          isInValid: false
        },
        scv: {
          message: '',
          isInValid: false
        },
        icv: {
          message: '',
          isInValid: false
        },
        pickup: {
          message: '',
          isInValid: false
        }
      };
      // if (resFrontData.truck.business_related_detail.length > 0) {
      //   resFrontData.truck.bias_radial_count = bias_radial_tyres.truck;
      //   // if (resFrontData.truck.bias_radial_count && Object.keys(resFrontData.truck.bias_radial_count).length <= 0) {
      //   //   ModalService.openAlert(messages.FLEET_REGISTRATION.ERRORMESSAGE, '', 'error');
      //   //   return
      //   // }
      //   let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.truck);
      //   if (resBusinessRelated !== true) {
      //     invalidCountError.truck.isInValid = true;
      //     invalidCountError.truck.message = resBusinessRelated;
      //   }
      // }
      // if (resFrontData.bus.business_related_detail.length > 0) {
      //   resFrontData.bus.bias_radial_count = bias_radial_tyres.bus;
      //   let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.bus);
      //   if (resBusinessRelated !== true) {
      //     invalidCountError.bus.isInValid = true;
      //     invalidCountError.bus.message = resBusinessRelated;
      //   }
      // }
      // if (resFrontData.scv.business_related_detail.length > 0) {
      //   let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.scv);
      //   if (resBusinessRelated !== true) {
      //     invalidCountError.scv.isInValid = true;
      //     invalidCountError.scv.message = resBusinessRelated;
      //   }
      // }
      // if (resFrontData.icv.business_related_detail.length > 0) {
      //   let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.icv);
      //   if (resBusinessRelated !== true) {
      //     invalidCountError.icv.isInValid = true;
      //     invalidCountError.icv.message = resBusinessRelated;
      //   }
      // }
      // if (resFrontData.pickup.business_related_detail.length > 0) {
      //   let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.pickup);
      //   if (resBusinessRelated !== true) {
      //     invalidCountError.pickup.isInValid = true;
      //     invalidCountError.pickup.message = resBusinessRelated;
      //   }
      // }
      // if (resFrontData.lcv.business_related_detail.length > 0) {
      //   let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.lcv);
      //   if (resBusinessRelated !== true) {
      //     invalidCountError.lcv.isInValid = true;
      //     invalidCountError.lcv.message = resBusinessRelated;
      //   }
      // }
      this.inValidCountVehicleDetailError(invalidCountError);
      return invalidCountError;
    }
  }

  inValidCountVehicleDetailError = (obj) => {
    if (this.refs.refVehicleDetail) {
      this.refs.refVehicleDetail.inValidCountVehicleDetailError(obj);
    }
  }

  setLoading = (isLoading) => {
    this.setState({
      isLoading: isLoading
    })
  }

  checkAllMandtoryFields = () => {
    let form1 = true; let form2 = true; let form3 = true, form4 = true, form5 = true,
      form6 = true;
    let { all_mandtory_error } = this.state;
    all_mandtory_error.is_business = false;
    all_mandtory_error.is_communication = false;
    all_mandtory_error.is_personal = false;
    all_mandtory_error.is_primary = false;
    if (!this.handleValidationBusiness(true)) {
      form1 = false;
      all_mandtory_error.is_business = true;
    }


    if (!this.childNewFleetPersonalDetails.current.handleValidation(true)) {
      form2 = false;
      all_mandtory_error.is_personal = true;
    }

    if (!this.handleValidationPrimary(true)) {
      form6 = false;
      all_mandtory_error.is_primary = true;
    }
    if (!this.childNewFleetPersonalDetails.current.handleValidation(true)) {
      form2 = false;
      all_mandtory_error.is_personal = true;
    }

    if (!this.childNewFleetCommunicationDetail.current.handleValidation(true)) {
      form3 = false;
      all_mandtory_error.is_communication = true;
    }
    // if (!this.refs.refCountVehicleDetail.handleValition()) {
    //   form4 = false;
    // }
    // if (!this.refs.refVehicleDetail.checkAllDataValidationFront()) {
    //   form5 = false;
    // }


    if (form1 === false) {
      this.scrollTo('form-business-detail');
    } else if (form6 === false) {
      this.scrollTo('form-primary-detail');
    } else if (form2 === false) {
      this.scrollTo('form-personal-detail');
    } else if (form3 === false) {
      this.scrollTo('form-communcation-detail');
    } else if (form4 === false) {
      this.scrollTo('form-vehicle-count-detail');
    } else if (form5 === false) {
      this.scrollTo('form-vehcicle-detail');
    }

    return !!(form1 === true && form2 === true && form3 === true && form4 === true &&
      form5 === true && form6 === true);
  }

  scrollTo(id) {
    var scroller = Scroll.scroller;
    scroller.scrollTo(id, {
      duration: 1000,
      delay: 100,
      smooth: "easeInOutQuint",
      offset: -80
    });
  }

  render() {
    const {
      controls,
      activeFragment,
      // isFleeData,
      isActionPageOpen,
      popupTitles,
      showBuildMyFleet,
      isListSubsidiaries,
    } = this.state;
    const {
      email,
      phone,
      gst,
      pan,
      wa,
      primaryPerson,
      primaryNumber,
      primaryDesignation,
      primaryWa,
      primaryEmail,
      birthDate,
      anniversaryDate,
      facebook,
      instagram,
      website,
      truck,
      bus,
      // scv,
      // lcv,
      sameAsUser,
      // agreeTermAndCondition,
    } = controls;

    let { communcationCardObj, personalDetailCardObj } = this.state;
    if (this.state.isCommuncationEditActive === false) {
      if (this.childNewFleetCommunicationDetail.current) {
        const communcationFields = communcationCardObj.fields;
        communcationFields[0].value = this.childNewFleetCommunicationDetail.current.state.controls.communication_address.value;
        communcationFields[1].value = this.childNewFleetCommunicationDetail.current.state.controls.communication_state_name.value;
        communcationFields[2].value = this.childNewFleetCommunicationDetail.current.state.controls.communication_city_name.value;
        communcationFields[3].value = this.childNewFleetCommunicationDetail.current.state.controls.communication_pin_code.value;
      }
    }
    if (this.state.isPersonalDetailEditActive === false) {
      if (this.childNewFleetPersonalDetails.current) {
        let personalDetailFields = personalDetailCardObj.fields;
        personalDetailFields = [];
        personalDetailFields.push({
          title: 'Home Address',
          value: this.childNewFleetPersonalDetails.current.state.controls.home_address.value
        })

        let birth_date = this.childNewFleetPersonalDetails.current.state.controls.birth_date.value;
        personalDetailFields.push({
          title: 'Date of Birth',
          value: birth_date ? moment(birth_date).format('DD MMM YYYY') : null
        })
        personalDetailFields.push({
          title: 'Educational Qualification',
          value: this.childNewFleetPersonalDetails.current.state.controls.education_qualification.value
        })
        personalDetailFields.push({
          title: 'Languages Known',
          value: null,
          isArray: true
        })
        if (this.childNewFleetPersonalDetails.current.state.controls.languages.value && this.childNewFleetPersonalDetails.current.state.controls.languages.value.length > 0) {

          let languages = this.childNewFleetPersonalDetails.current.state.controls.languages.value;
          personalDetailFields[3].value = [];
          languages.forEach(element => {
            personalDetailFields[3].value.push(element.value);
          });
        } else {
          personalDetailFields[3].value = null;
        }

        if (this.childNewFleetPersonalDetails.current.state.controls.marital_status.value === 'unmarried') {

          personalDetailFields.push({
            title: 'Marital Status',
            value: 'Unmarried'
          })
        } else if (this.childNewFleetPersonalDetails.current.state.controls.marital_status.value === 'married') {

          personalDetailFields.push({
            title: 'Marital Status',
            value: 'Married'
          })
        } else {
          // personalDetailFields.push({
          //   title: 'Marital Status',
          //   value: this.childNewFleetPersonalDetails.current.state.controls.marital_status.value == true ||
          //     this.childNewFleetPersonalDetails.current.state.controls.marital_status.value == 'true' ? 'Married' : 'Unmarried'
          // })
        }


        if (this.childNewFleetPersonalDetails.current.state.controls.marital_status.value) {
          let anniversary_date = this.childNewFleetPersonalDetails.current.state.controls.anniversary_date.value;
          personalDetailFields.push({
            title: 'Date of Anniversary',
            value: anniversary_date ? moment(anniversary_date).format('DD MMM YYYY') : null
          });
          personalDetailFields.push({
            title: 'Spouse Name',
            value: this.childNewFleetPersonalDetails.current.state.controls.spouse_name.value
          });
          let spouse_dob = this.childNewFleetPersonalDetails.current.state.controls.spouse_dob.value;
          personalDetailFields.push({
            title: 'Spouse DOB',
            value: spouse_dob ? moment(spouse_dob).format('DD MMM YYYY') : null
          });
          personalDetailFields.push({
            title: 'Child 1 Name',
            value: this.childNewFleetPersonalDetails.current.state.controls.child_1_name.value
          });
          let child_1_dob = this.childNewFleetPersonalDetails.current.state.controls.child_1_dob.value ? this.childNewFleetPersonalDetails.current.state.controls.child_1_dob.value : null;
          personalDetailFields.push({
            title: 'Child 1 DOB',
            value: child_1_dob ? moment(child_1_dob).format('DD MMM YYYY') : null
          });
          personalDetailFields.push({
            title: 'Child 2 Name',
            value: this.childNewFleetPersonalDetails.current.state.controls.child_2_name.value
          });
          let child_2_dob = this.childNewFleetPersonalDetails.current.state.controls.child_2_dob.value ? this.childNewFleetPersonalDetails.current.state.controls.child_2_dob.value : null;
          personalDetailFields.push({
            title: 'Child 2 DOB',
            value: child_2_dob ? moment(child_2_dob).format('DD MMM YYYY') : null
          });
        }
        personalDetailCardObj.fields = personalDetailFields;
      }
    }

    return (
      <div id="profile" >
        {this.state.isLoading && <CustomSpinner />}
        {
          this.stateAddEditSubsidiaries.addEditSubsidiaries && this.stateAddEditSubsidiaries.addEditSubsidiaries.length > 0 &&
          <Sidebar
            sidebar={<>
              <div className="drawer-header">
                <span className="drawer-title">{this.state.isAddSubsidiaries ? 'Add' : 'Edit'} Subsidiaries</span>
                <img className="cursor-pointer" src="images/close.svg" alt='close' onClick={() => { this.onCloseSidebar(); }} />
              </div>
              <hr style={{ border: 'solid 1px #ced4da' }} />
              <AddEditSubsidiaries
                fleet_id={this.state.fleet_id}
                editSubsidiariesIndex={this.state.editSubsidiariesIndex}
                addEditSubsidiaries={Object.assign([], this.stateAddEditSubsidiaries.addEditSubsidiaries)}
                isAddSubsidiaries={this.state.isAddSubsidiaries}
                addSubsidiaries={this.addSubsidiaries} ref="childAddEditSubsidiaries"
                listSubsidiaries={[...this.stateAddEditSubsidiaries.addEditSubsidiaries]}
                editSubsidiaries={this.editSubsidiaries}
                removeSubsidiaries={this.removeSubsidiaries} />
            </>}
            open={this.state.sidebarOpen}
            sidebarClassName="subsdiaries-sidebar"
            pullRight
            styles={{ sidebar: { background: 'white', height: '90%', top: '60px' } }}
          />
        }
        {
          this.state.isOpenAddEditVehicle &&
          <Sidebar
            sidebar={
              <AddEditFleetVehicle
                fleet_id={this.state.fleet_id}
                addEditVehicleType={this.state.addEditVehicleType}
                vehicleData={this.state.vehicleData}
                vehicle_type={this.state.addEditVehicleType}
                closeSideBar={this.closeSideBarAddEditVehicle}
                submitVehclies={this.submitVehclies}
                uuid={this.state.uuid}
                isAddVehicleDetail={this.state.isAddVehicleDetail}
                from="profile" />
            }
            open={this.state.isOpenAddEditVehicle}
            sidebarClassName="subsdiaries-sidebar"
            pullRight
            styles={{ sidebar: { background: 'white', height: '100%', width: '40%' } }}
          />
        }

        {
          isActionPageOpen &&
          <Sidebar
            sidebar={
              <>
                <div className="drawer-header">
                  <span className="drawer-title">My Actions</span>
                  <img
                    className="cursor-pointer"
                    src="images/close.svg"
                    onClick={() => {
                      this.closeActionSidebar();
                    }}
                    alt='close'
                  />
                </div>
                <hr style={{ border: "solid 1px #ced4da" }} />
                <ActionScreen titles={popupTitles} />
              </>
            }
            open={isActionPageOpen}
            sidebarClassName="action-screen-sidebar"
            pullRight
            styles={{
              sidebar: { background: "white", height: "90%", top: "60px" },
            }}
          />
        }

        <>
          {showBuildMyFleet && (
            <FleetRegistration
              buildMyFleetClick={this.buildMyFleetClick}
              truck={truck}
              bus={bus}
              updateTruckBusData={this.updateTruckBusData}
              from="profile"
            />
          )}
        </>

        {this.state.fleet_id && (<Row className="margin-bottom-20" style={{ marginLeft: '-15px' }}>
          <Col className="title title-case">
            <span
              className={'prev-page-link cursor-pointer title-case'}
              onClick={this.openFleetdeatil}>Fleet Details</span>
            <span>
              <Ionicon icon="ios-arrow-forward" fontSize="34px" color="#fdbb1f" />
            </span>
            <span className={'title-case title-css'}>
              Profile Details of ({this.state.ownerName})
            </span>
          </Col>
        </Row>)}
        {!showBuildMyFleet && (
          <Row>
            <Col xl="3" className="margin-top-10">
              <ProfileDetail
                sapId={this.state.sapId}
                fleet_id={this.state.fleet_id}
                businessName={this.state.businessName}
                ownerName={this.state.ownerName}
                address={this.state.address}
                profileImage={this.state.profileImage}
                isImageUpdating={this.state.isImageUpdating}
                handleUploadImage={this.handleUploadImage}
                openRequestDetailModal={this.openRequestDetailModal}
                updateReqButton={this.updateReqButton}
                isUpdateProfileRequestSend={
                  this.state.isUpdateProfileRequestSend
                }
                showRequestButton
              />
              {isListSubsidiaries && (
                <ListSubsidiaries
                  listSubsidiaries={Object.assign(
                    [],
                    this.stateAddEditSubsidiaries.addEditSubsidiaries
                  )}
                  removeSubsidiaries={this.removeSubsidiaries}
                  addMoreSubsidiaries={this.onSetSidebarOpen}
                  editSubsidiaries={this.editSubsidiaries}
                />
              )}
              {popupTitles && popupTitles.length > 0 && (
                <Card className="margin-top-5 cursor-pointer">
                  <CardBody>
                    <Row onClick={this.openActionSidebar}>
                      <Col>
                        <div className="action-button">My Actions</div>
                      </Col>
                      <Col className="text-align-right">
                        <Ionicon
                          icon="ios-arrow-forward"
                          fontSize="24px"
                          color="#fdbb1f"
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              )}
            </Col>
            <Col xl="9" className="margin-top-10">
              <Row id="form-business-detail">
                <Col className={this.state.isBusinessEditActive === false ? '' : 'hidden'}>
                  <DetailCard makeEditActive={this.makeEditActive} cardObj={this.state.businessCardObj}
                    is_error={this.state.all_mandtory_error.is_business}
                  />
                </Col>
                <Col className={this.state.isBusinessEditActive === true ? '' : 'hidden'}>
                  <EditOtherBusinessDetail
                    email={email}
                    phone={phone}
                    gst={gst}
                    pan={pan}
                    wa={wa}
                    className={activeFragment === 'business' ? 'card-yellow-border' : ''}
                    handleInputChange={this.handleInputChange}
                    activeFragment={this.activeFragment}
                    onCancel={this.makeEditActive}
                    onSave={this.handleBusinessSave}
                    controls={this.state.controls}
                    ref={this.childFleetBusinessDetail}
                    refresh_state={this.refresh_state}
                    isFormValid={this.state.isBusinessFormValid}
                  />
                </Col>
              </Row>
              <br />

              <Row id="form-primary-detail">
                <Col className={this.state.isContactEditActive === false ? '' : 'hidden'}>
                  <DetailCard makeEditActive={this.makeEditActive} cardObj={this.state.contactCardObj}
                    is_error={this.state.all_mandtory_error.is_primary} />

                </Col>
                <Col xl="12" className={this.state.isContactEditActive === true ? '' : 'hidden'} onClick={this.activeFragment.bind(this, 'contact')}>
                  <EditPrimaryContactDetail
                    primaryPerson={primaryPerson}
                    primaryDesignation={primaryDesignation}
                    primaryNumber={primaryNumber}
                    primaryWa={primaryWa}
                    primaryEmail={primaryEmail}
                    sameAsUser={sameAsUser}
                    className={activeFragment === 'contact' ? 'card-yellow-border' : ''}
                    handleInputChange={this.handleInputChange}
                    activeFragment={this.activeFragment}
                    onCancel={this.makeEditActive}
                    NewFleetBusinessDetail={this.childNewFleetBusinessDetail}
                    onSave={this.handleContactSave}
                    isFormValid={this.state.isContactFormValid}
                    ref={this.childPrimaryContact}
                    setSameAsUserCheckBoxValue={this.setSameAsUserCheckBoxValue}
                  />
                </Col>
              </Row>
              <Row className="mt-4" id="form-communcation-detail">
                <Col className={this.state.isCommuncationEditActive === false ? '' : 'hidden'}>
                  <DetailCard makeEditActive={this.makeEditActive} cardObj={communcationCardObj}
                    is_error={this.state.all_mandtory_error.is_communication} />
                </Col>

                <Col xl="12" className={this.state.isCommuncationEditActive === true ? '' : 'hidden'}>
                  <NewFleetCommunicationDetail
                    ref={this.childNewFleetCommunicationDetail}
                    NewFleetBusinessDetail={Object.assign({}, {
                      current:
                        this
                    }
                    )}
                    refresh_state={this.refresh_state}
                    from='profile'
                    refEditOtherBusinessDetail={this.childFleetBusinessDetail}
                    onSave={this.handleCommuncationSave}
                    onCancel={this.makeEditActive}
                    fleetByIdData={null} />
                </Col>

              </Row>
              <Row id="form-personal-detail" className="mt-4">
                <Col className={this.state.isPersonalDetailEditActive === false ? '' : 'hidden'}>
                  <DetailCard makeEditActive={this.makeEditActive} cardObj={personalDetailCardObj}
                    is_error={this.state.all_mandtory_error.is_personal} />
                </Col>

                <Col xl="12" className={this.state.isPersonalDetailEditActive === true ? '' : 'hidden'}>
                  <NewFleetPersonalDetails
                    ref={this.childNewFleetPersonalDetails}
                    NewFleetBusinessDetail={this.childNewFleetBusinessDetail}
                    refresh_state={this.refresh_state}
                    from='profile'
                    onSave={this.handlePersonalDetailSave}
                    onCancel={this.makeEditActive}
                    fleetByIdData={null} />
                </Col>
              </Row>

              <br />

              <Row>
                {this.state.isSocialEditActive === false && (
                  <Col>
                    <DetailCard
                      makeEditActive={this.makeEditActive}
                      cardObj={this.state.socialCardObj}
                    />
                  </Col>
                )}
                {this.state.isSocialEditActive === true && (
                  <Col onClick={this.activeFragment.bind(this, "social")}>
                    <EditSocialDetails
                      birthDate={birthDate}
                      anniversaryDate={anniversaryDate}
                      facebook={facebook}
                      instagram={instagram}
                      website={website}
                      className={
                        activeFragment === "social" ? "card-yellow-border" : ""
                      }
                      handleInputChange={this.handleInputChange}
                      activeFragment={this.activeFragment}
                      onCancel={this.makeEditActive}
                      onSave={this.handleSocialSave}
                      handleBirthDateChange={this.handleBirthDateChange}
                      handleAnniversaryDateChange={
                        this.handleAnniversaryDateChange
                      }
                      isFormValid={this.state.isSocialFormValid}
                    />
                  </Col>
                )}
              </Row>
              <Row id="form-vehcicle-count-detail" style={{ padding: '15px' }}>
                <VehicleCountDeatil
                  ref="refCountVehicleDetail"
                  uuid={null}
                  from="registration"
                  deleteFleetVehicle={this.deleteFleetVehicle}
                  openAddEditVehicle={(type, isAddVehicle) => this.openAddEditVehicle(type, isAddVehicle)} />
              </Row>
              <Row id="form-vehcicle-detail" style={{ padding: '15px' }}>
                <div id="VehicleDetail" className="w-100">
                  {/* <VehicleDetail
                    fleetByIdData={null}
                    ref="refVehicleDetail"
                    vehicleData={this.state.vehicleData} /> */}
                </div>
              </Row>
              <br />
              {/* <br />
              <Row
                onClick={this.activeFragment.bind(this, 'fleet')}
              >
                <Col>
                  <EditFleetDetail
                    className={
                      activeFragment === "fleet" ? "card-yellow-border" : ""
                    }
                    truck={truck}
                    bus={bus}
                    scv={scv}
                    lcv={lcv}
                    handleFleetSave={this.handleFleetSave}
                    makeEditActiveFleet={this.makeEditActiveFleet}
                    handleInputChange={this.handleInputChange}
                    activeFragment={this.activeFragment}
                    buildMyFleetClick={this.buildMyFleetClick}
                    isFleeData={isFleeData}
                  />
                </Col> 
              </Row>*/}
              <Row
              // onClick={this.activeFragment.bind(this, 'social')}
              >
                {/* <Col xs="12" md="6" className="margin-top-15">
                  {!isListSubsidiaries && (
                    <Button
                      className="bottom-button"
                      onClick={() => this.onSetSidebarOpen(true)}
                    >
                      ADD SUBSIDIARIES
                    </Button>
                  )}
                </Col> */}
                <Col xs="12" md="12" className="margin-top-15 text-align-right">
                  <Button
                    className="mb-1 mr-1 btn-pill action-button action-ob-button"
                    color="warning"
                    style={{ fontSize: '13px', width: '125px' }}
                    onClick={this.updateProfile}
                  // disabled={!isFormValid}
                  >
                    Submit
                  </Button>
                  {/* {
                    !isFleeData &&
                    <Button onClick={(e) => this.buildMyFleetClick(true)} className="bottom-button">
                      BUILD MY FLEET
                    </Button>
                  } */}
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setUserDetail: (user) => dispatch(setUserDetail(user)),
  isProfileUpdate: (bool) => dispatch(isProfileUpdate(bool)),
});

const mapStateToProp = (state) => ({
  // userDetail: state.User.user,
});

export default connect(
  mapStateToProp,
  mapDispatchToProps
)(Profile);

// export default Profile;
